/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import router from './router';
import Breadcrumbs from './components/bread_crumbs_new';
import { store } from './store';
import Vue2Filters from 'vue2-filters';
import VueSweetalert2 from 'vue-sweetalert2';
import VueFormWizard from 'vue-form-wizard';
import Notifications from 'vue-notification';
import { Vue2Dragula } from 'vue2-dragula';
import Toasted from 'vue-toasted';
import SmartTable from 'vuejs-smart-table';
//import * as VueGoogleMaps from 'vue2-google-maps';
import { VueMasonryPlugin } from 'vue-masonry';
import VueFeather from 'vue-feather';
import VueApexCharts from 'vue-apexcharts';
//import FunctionalCalendar from 'vue-functional-calendar';
//import vueKanban from 'vue-kanban';
import vueSelectSides from 'vue-select-sides';
import draggable from 'vuedraggable';
import CKEditor from '@ckeditor/ckeditor5-vue';
import vSelect from 'vue-select';
import PxCard from './components/Pxcard.vue';
import ToggleButton from 'vue-js-toggle-button';
import VueQuillEditor from 'vue-quill-editor';
import '/node_modules/vue-select-sides/styles/themes/light.scss';

import 'quill/dist/quill.snow.css'; // for snow theme
import dataTableVue from './components/datatable/data-table.vue';

Vue.component(PxCard.name, PxCard);

import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fas, far, fab);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Toasted, {
  iconPack: 'fontawesome',
});


// Multi Language Add
import en from './locales/en.json';
import es from './locales/es.json';
import th from './locales/th.json';
import { defaultLocale, localeOptions } from './constants/config';
import VueI18n from 'vue-i18n';

import DatePicker from 'vue2-datepicker';
import VueTagsInput from '@johmun/vue-tags-input';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import loading from 'vuejs-loading-screen';
// Import Theme scss
import './assets/scss/app.scss';
import 'vue2-datepicker/index.css';
Icon.Default.mergeOptions({
  iconRetinaUrl: require('./assets/images/vue2leaflet/marker-icon.png'),
  iconUrl: require('./assets/images/vue2leaflet/marker-icon.png'),
});

Vue.use(VueQuillEditor /* { default global options } */);
Vue.use(VueFeather);
Vue.use(ToggleButton);
Vue.use(Toasted, {
  iconPack: 'fontawesome',
});
Vue.use(Vue2Dragula);

/*Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCdXpLSJ3Ibdu-Phs9QOvpqb9d1DtPf7wQ',
    libraries: 'places',
  },
});*/

Vue.use(vueSelectSides);
Vue.component('vue-select-sides', vueSelectSides);

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});
extend("customRegexCRLF", {
  validate: (value) => {
    // Define the regular expression to match <, >, ', and ,
    const regexLineBreaks = /(\r\n|\n)/g;
    return !regexLineBreaks.test(value) ;
  },
  message: "Invalid characters found: <, >, ', ,",
});
extend("customRegex", {
  validate: (value) => {
    const regex = /[<>'',|;$%@""=]/;
    // Test if the value matches the regex
    return !regex.test(value);
  },
  message: "Invalid characters found: [<>\',|;$%@\"=]",
});
extend("max_length200", {
  validate: (value) => {
    if (typeof value === 'string') {
      return value.length <= 200;
    } else {
      return true;
    }
  },
  message: "This value may not greather than 200 characters",
});

// Install components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.component('date-picker', DatePicker);
Vue.component('vue-tags-input', VueTagsInput);
Vue.component('v-select', vSelect);
Vue.use(CKEditor);
Vue.use(Notifications);
Vue.use(Vue2Filters);
Vue.use(VueSweetalert2);
Vue.use(VueFormWizard);
Vue.use(BootstrapVue);
Vue.use(SmartTable);
Vue.use(require('vue-chartist'));
Vue.use(require('vue-moment'));
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.component('draggable', draggable);

Vue.use(loading, {
  bg: '#ffffffad',
  slot: `
  <iconify-icon icon="line-md:loading-twotone-loop" style="color: #007bff;" width="150" height="150"></iconify-icon>
  `,
});
Vue.component('dataTableVue', dataTableVue);

Vue.use(VueMasonryPlugin);
Vue.component('apexchart', VueApexCharts);
/*Vue.use(FunctionalCalendar, {
  dayNames: ['M', 'T', 'W', 'T', 'F', 'S', 'S']
});
Vue.use(vueKanban);*/
Vue.use(VueI18n);


const messages = { en: en, es: es, th: th };
const locale =
  localStorage.getItem('currentLanguage') &&
  localeOptions.filter((x) => x.id === localStorage.getItem('currentLanguage'))
    .length > 0
    ? localStorage.getItem('currentLanguage')
    : defaultLocale;
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true,
});

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
